query AutocompleteProducts(
  $input: String
  $value: [ID!]
  $type: ProductType
  $includeIds: [ID!]
  $excludeIds: [ID!]
) {
  autocompleteProducts(
    input: $input
    value: $value
    type: $type
    includeIds: $includeIds
    excludeIds: $excludeIds
  ) {
    options {
      value
      label
    }
    value {
      value
      label
    }
  }
}
